import { Link } from 'react-router-dom'

import { Card, EmptyState } from '@/design'
import { usePermissions } from '@/lib/access'

import { advertisingErrorMessage } from './errors'

/** The flag is off, or nothing is connected/mapped: either way, the fix is Integrations. */
export function ConnectMeta({ reason }: { reason: 'not_entitled' | 'not_connected' }) {
  const { can } = usePermissions()
  const title = reason === 'not_entitled' ? 'Meta advertising is not enabled' : 'No Meta ad account is feeding a website'
  const description =
    reason === 'not_entitled'
      ? 'This workspace does not have Meta advertising reporting turned on. Ask an Owner to enable it.'
      : can('integrations.manage')
        ? 'Connect Meta and map at least one ad account to a website to see campaign spend and delivery here.'
        : 'An Owner or Administrator can connect Meta in Settings › Integrations.'
  return (
    <Card>
      <EmptyState
        variant="disconnected"
        title={title}
        description={description}
        action={
          can('integrations.manage') && reason === 'not_connected' ? (
            <Link className="ci-button" data-variant="primary" to="/integrations">
              Connect Meta
            </Link>
          ) : undefined
        }
      />
    </Card>
  )
}

export function NoRows({ from, to }: { from: string; to: string }) {
  return (
    <Card>
      <EmptyState
        variant="no-results"
        title="No campaign spend in this period"
        description={`Meta reported no delivery from ${from} to ${to}. Try a wider date range.`}
      />
    </Card>
  )
}

export function AdvertisingError({ error }: { error: unknown }) {
  return (
    <Card>
      <EmptyState variant="outage" title="Campaign report could not be loaded" description={advertisingErrorMessage(error)} announce />
    </Card>
  )
}
